var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2000_8233)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2000_8233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "#DBF1D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0035 34.546C28.0367 34.546 34.5489 28.0338 34.5489 20.0005C34.5489 11.9673 28.0367 5.45508 20.0035 5.45508C11.9702 5.45508 5.45801 11.9673 5.45801 20.0005C5.45801 28.0338 11.9702 34.546 20.0035 34.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9857 32.5467C26.8917 32.5467 32.49 26.9483 32.49 20.0424C32.49 13.1365 26.8917 7.53809 19.9857 7.53809C13.0798 7.53809 7.48145 13.1365 7.48145 20.0424C7.48145 26.9483 13.0798 32.5467 19.9857 32.5467Z",
    fill: "#50B651"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.663,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4494 20.0063C32.4494 23.3331 31.1278 26.5236 28.7754 28.876C26.4231 31.2283 23.2326 32.5499 19.9058 32.5499C16.5791 32.5499 13.3886 31.2283 11.0362 28.876C8.68385 26.5236 7.3623 23.3331 7.3623 20.0063C7.3623 16.9421 7.44806 16.4859 8.65406 14.7417C8.6515 15.3333 8.77329 15.9189 9.01153 16.4605C9.24978 17.002 9.59916 17.4875 10.037 17.8853C10.9356 18.6151 11.8734 18.0879 13.5894 17.2978C15.4458 16.4421 16.9556 15.8903 18.1333 16.0353C19.9077 16.2552 25.3748 19.5384 28.2283 18.8852C30.509 18.3643 30.2672 12.9893 30.2672 12.9893C32.7568 15.4195 32.4494 17.0625 32.4494 20.0063Z",
    fill: "url(#paint0_linear_2000_8233)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.586,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.29 29.2162C29.8264 24.9493 30.5805 20.0608 27.5524 14.5508C27.5676 14.5617 27.755 13.9152 28.1144 12.6113C29.762 14.6613 30.668 17.2082 30.6851 19.8382C30.6845 23.5523 28.8862 26.6783 25.29 29.2162Z",
    fill: "url(#paint1_linear_2000_8233)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.744,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1382 12.6391C20.9487 11.4276 18.4364 8.99005 18.7703 8.47736C19.1042 7.96467 23.4383 8.05316 25.6286 9.26555C27.819 10.4779 29.6827 14.1124 29.3488 14.6251C29.0149 15.1377 25.3276 13.8515 23.1382 12.6391Z",
    fill: "url(#paint2_radial_2000_8233)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0447 23.1201C24.3716 23.139 23.7081 22.9566 23.1391 22.5963C22.5702 22.236 22.1216 21.7142 21.8509 21.0976C21.5802 20.4809 21.4996 19.7975 21.6194 19.1348C21.7393 18.4721 22.0541 17.8602 22.5236 17.3775C22.9931 16.8947 23.5959 16.5629 24.255 16.4246C24.9141 16.2864 25.5995 16.3479 26.2235 16.6013C26.8474 16.8547 27.3816 17.2885 27.7576 17.8472C28.1337 18.4059 28.3345 19.0641 28.3344 19.7375C28.3465 20.6223 28.0069 21.4756 27.39 22.11C26.7731 22.7443 25.9295 23.1077 25.0447 23.1201ZM25.0685 22.0473C25.5368 22.1023 26.0107 22.0136 26.4274 21.793C26.8442 21.5724 27.1839 21.2303 27.4017 20.8121C27.6196 20.3939 27.7051 19.9194 27.6471 19.4515C27.589 18.9836 27.3901 18.5444 27.0767 18.1921C26.7632 17.8399 26.3501 17.5912 25.8921 17.4792C25.4341 17.3671 24.9529 17.3969 24.5122 17.5646C24.0716 17.7323 23.6923 18.03 23.4247 18.4183C23.1572 18.8065 23.014 19.2669 23.0141 19.7384C22.9814 20.3166 23.1791 20.8842 23.564 21.317C23.9489 21.7497 24.4904 22.0123 25.0685 22.0473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2598 13.6309H20.6316V23.0827H19.3308V14.6681H18.2598V13.6309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4924 16.4509H17.723V24.3438C17.6506 24.7461 17.4749 25.1227 17.2131 25.4366C16.9513 25.7506 16.6124 25.9911 16.2296 26.1345C15.606 26.3314 14.954 26.4239 14.3002 26.4082V25.6228C14.9669 25.6106 15.6143 25.3973 16.1576 25.0106C16.3426 24.7533 16.4582 24.4526 16.4933 24.1376V21.8187C16.3862 22.1344 16.2138 22.424 15.9872 22.6686C15.7607 22.9132 15.4851 23.1073 15.1785 23.2383C14.8719 23.3692 14.5411 23.434 14.2077 23.4285C13.8744 23.4229 13.5459 23.3472 13.2438 23.2062C12.5931 22.8006 12.1119 22.1723 11.89 21.4383C11.7151 20.8979 11.6277 20.3331 11.6309 19.7652C11.6454 19.1616 11.7961 18.5691 12.0716 18.0319C12.4391 17.3841 13.0139 16.879 13.7036 16.5978C14.4024 16.439 15.1218 16.391 15.8355 16.4555V17.2364C15.3544 17.1598 14.8624 17.1866 14.3924 17.3148C14.1059 17.4708 13.4591 17.6624 13.2456 19.0728C13.0322 20.4831 13.252 21.6371 13.9289 21.9984C14.0814 22.0881 14.25 22.1468 14.4252 22.1712C14.6003 22.1956 14.7786 22.1853 14.9497 22.1407C15.3165 21.991 15.6414 21.7546 15.8968 21.4518C16.1521 21.1489 16.3302 20.7887 16.4157 20.4019C16.4668 19.7889 16.4924 18.4719 16.4924 16.4509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0569 22.5177C31.6453 24.4906 30.7559 26.3323 29.4666 27.8813C28.1773 29.4303 26.5276 30.6392 24.6622 31.402C22.7967 32.1647 20.7726 32.4581 18.7674 32.2562C16.7622 32.0543 14.8372 31.3634 13.1612 30.2442C11.4853 29.1249 10.1096 27.6114 9.15494 25.8365C8.20027 24.0616 7.69577 22.0796 7.6857 20.0642C7.67563 18.0489 8.16028 16.0619 9.09716 14.2776C10.034 12.4932 11.3945 10.9661 13.0592 9.83008C11.6303 11.0153 10.4979 12.5178 9.75241 14.218C9.00687 15.9182 8.66874 17.769 8.76495 19.623C8.86117 21.4769 9.38909 23.2828 10.3066 24.8967C11.2242 26.5106 12.5059 27.8878 14.0499 28.9187C15.5938 29.9496 17.3571 30.6057 19.1994 30.8346C21.0417 31.0636 22.912 30.859 24.6613 30.2373C26.4106 29.6156 27.9905 28.594 29.2751 27.2538C30.5597 25.9135 31.5135 24.2918 32.0606 22.5177H32.0569Z",
    fill: "url(#paint3_radial_2000_8233)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9984 5.41602C17.1142 5.4162 14.2947 6.27165 11.8966 7.87419C9.49853 9.47674 7.62949 11.7544 6.52585 14.4192C5.42221 17.084 5.13354 20.0161 5.69635 22.845C6.25915 25.6738 7.64815 28.2722 9.6877 30.3116C11.7273 32.3511 14.3258 33.7399 17.1546 34.3025C19.9835 34.8652 22.9157 34.5763 25.5804 33.4725C28.2451 32.3687 30.5226 30.4995 32.125 28.1013C33.7274 25.7031 34.5827 22.8836 34.5827 19.9993C34.5827 18.0842 34.2054 16.1877 33.4725 14.4183C32.7396 12.6489 31.6653 11.0413 30.311 9.68705C28.9567 8.33285 27.349 7.25867 25.5795 6.52584C23.8101 5.79302 21.9136 5.4159 19.9984 5.41602ZM19.9984 32.3139C17.4587 32.311 14.9821 31.5221 12.9087 30.0555C10.8352 28.5888 9.26659 26.5163 8.41813 24.1224C7.56966 21.7286 7.48296 19.1309 8.16994 16.6858C8.85691 14.2407 10.2839 12.0682 12.2549 10.4666C14.226 8.86494 16.6444 7.91265 19.1783 7.74047C21.7122 7.56829 24.2373 8.18466 26.4069 9.50495C28.5765 10.8252 30.2842 12.7847 31.2956 15.1144C32.3071 17.444 32.5726 20.0297 32.0557 22.5163C31.4773 25.2859 29.9628 27.7719 27.767 29.5562C25.5711 31.3405 22.8278 32.3143 19.9984 32.3139Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2000_8233",
    x1: 19.4099,
    y1: 14.7106,
    x2: 20.4037,
    y2: 29.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#123214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3E7C37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#5FBB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2000_8233",
    x1: 154.109,
    y1: -61.2472,
    x2: 154.109,
    y2: -61.2804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "white",
    stopOpacity: 0.431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2000_8233",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-186.808 154.964) rotate(42.9447) scale(7.3168 2.1761)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "white",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "white",
    stopOpacity: 0.051
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2000_8233",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-110.699 63.4604) rotate(42.1567) scale(14.3403 14.5828)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopOpacity: 0.471
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2000_8233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2000_8233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlo);
export default __webpack_public_path__ + "static/media/glo.3aba91f5.svg";
export { ForwardRef as ReactComponent };